const DOLLAR_CENTS_AMOUNT = 100;
export const formatMoney = (valueInCents, minimumFractionDigits = 2) => {
    const value = convertCentsToDollars(valueInCents);
    return value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits,
    });
};
export const convertCentsToDollars = (amount) => {
    return (amount ?? 0) / DOLLAR_CENTS_AMOUNT;
};
export const convertDollarsToCents = (amount) => {
    // TODO: Inaccuracies in rounding are possible. Something needs to be done about this in the future
    return Number(((amount ?? 0) * DOLLAR_CENTS_AMOUNT).toFixed());
};
//# sourceMappingURL=money.js.map